import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @export
 * Content wrapper for a configuration section — applies the standard scroll and
 * overflow behaviour (flex-grow, overflow-y: auto). Use alongside
 * ConfigurationViewHeader inside `hideHeader: true` sections so the content area
 * matches the built-in ConfigurationView layout exactly.
 *
 * @example
 * ```tsx
 * <ConfigurationViewHeader title="Login Page Configuration" actions={...} />
 * <ConfigurationViewContent>
 *   <TabComponent tabs={tabs} />
 * </ConfigurationViewContent>
 * ```
 */
export const ConfigurationViewContent = ({ children }) => {
    return (_jsx("div", { className: 'uxpcore_configview__content-body', children: children }));
};
